import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";

export default function Breadcrumbs({ items }) {
  // items is an array like: [{ name: "Dashboard", path: "/dashboard" }, { name: "All Short URLs" }]
  return (
    <nav aria-label="breadcrumb" className="mb-3">
      <ol className="breadcrumb mb-0" style={{marginLeft: "15px"}}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li
              key={index}
              className={`breadcrumb-item ${isLast ? "active" : ""}`}
              aria-current={isLast ? "page" : undefined}
            >
              {!isLast ? (
                <Link to={item.path} className="text-decoration-none">
                  {item.name} <FaChevronRight className="ms-1" style={{ fontSize: "0.7rem" }} />
                </Link>
              ) : (
                item.name
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
